import { useEffect } from 'react';

import { useWorkspaceUiStore } from '@walls/store';

interface UseWorkspaceClipboardOptions {
  enabled: boolean;
}

export const useWorkspaceClipboard = ({ enabled }: UseWorkspaceClipboardOptions) => {
  const setSelectedTool = useWorkspaceUiStore((state) => state.setSelectedTool);

  useEffect(() => {
    if (!enabled) {
      return;
    }

    const handlePaste = (event: ClipboardEvent) => {
      const items = Array.from(event.clipboardData?.items ?? []);
      const hasSupportedContent = items.some(
        (item) => item.type.indexOf('image') === 0 || item.type === 'text/plain'
      );

      if (hasSupportedContent) {
        setSelectedTool('pointer');
      }
    };

    document.addEventListener('paste', handlePaste);

    return () => {
      document.removeEventListener('paste', handlePaste);
    };
  }, [enabled, setSelectedTool]);
};
